<mat-expansion-panel #panel="matExpansionPanel"
                     class="panel-container"
                     [ngClass]="{'panel-container--error': canMarkInvalidSection && form.invalid}">
  <mat-expansion-panel-header class="panel-header"
                              collapsedHeight="72px"
                              expandedHeight="76px">
    <ifbp-form-details-section-header [config]="headerConfig"
                                      [iconType]="canMarkInvalidSection && form.invalid ? IconType.Warning : form.dirty ? IconType.Changes : IconType.Default">
    </ifbp-form-details-section-header>
  </mat-expansion-panel-header>
  <form class="form">
    <ng-container *ngFor="let ownerForm of form.controls; let ownerIndex = index;"
                  [formGroup]="ownerForm">
      <div class="owner">
        <span class="owner__title">Owner {{ ownerIndex + 1 }}</span>
        <button class="owner__remove-button"
                *ngIf="ownerForm.get('canRemove')?.value"
                (click)="removeOwner(ownerIndex)"
                mat-button
                type="button">
          <mat-icon class="owner__remove-icon">cancel</mat-icon>
          <span>REMOVE</span>
        </button>
      </div>
      <div class="form__section">
        <div class="form__row">
          <mat-form-field class="form__field"
                          appearance="outline">
            <mat-label>First name</mat-label>
            <input matInput
                   formControlName="firstName" />
            <mat-error *ngIf="ownerForm.get('firstName').errors | hasControlError:['required']">First name is required.</mat-error>
            <mat-error *ngIf="ownerForm.get('firstName').errors | hasControlError:['maxlength']">First name is too long.</mat-error>
          </mat-form-field>

          <mat-form-field class="form__field"
                          appearance="outline">
            <mat-label>Last name</mat-label>
            <input matInput
                   formControlName="lastName" />
            <mat-error *ngIf="ownerForm.get('lastName').errors | hasControlError:['required']">Last name is required.</mat-error>
            <mat-error *ngIf="ownerForm.get('lastName').errors | hasControlError:['maxlength']">Last name is too long.</mat-error>
          </mat-form-field>
        </div>

        <div class="form__row">
          <mat-form-field class="form__field"
                          appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput
                   formControlName="email" />
            <mat-error *ngIf="ownerForm.get('email').errors | hasControlError:['required']">Email is required.</mat-error>
            <mat-error *ngIf="ownerForm.get('email').errors | hasControlError:['maxlength']">Email is too long.</mat-error>
            <mat-error *ngIf="ownerForm.get('email').errors | hasControlError:['email']:ConditionOperator.Only">Please enter a valid email.</mat-error>
          </mat-form-field>

          <mat-form-field class="form__field"
                          appearance="outline">
            <mat-label>Mobile phone number</mat-label>
            <input matInput
                   formControlName="mobilePhone"
                   mask="(000) 000-0000" />
            <mat-error *ngIf="ownerForm.get('mobilePhone').errors | hasControlError:['required']">Mobile phone number is required.</mat-error>
            <mat-error *ngIf="ownerForm.get('mobilePhone').errors | hasControlError:['pattern']">Please enter a valid mobile phone number.</mat-error>
          </mat-form-field>
        </div>
      </div>

      <span class="form__subheader">Home address</span>
      <ifbp-address-form [form]="ownerForm.controls.address"></ifbp-address-form>

      <div class="form__section">
        <div class="form__row">
          <div class="form__field">
            <ifc-datepicker id="date-form-field"
                            [fc]="ownerForm.controls.birthdate"
                            [min]="minDate"
                            [max]="maxDate"
                            label="Date of birth">
            </ifc-datepicker>
          </div>

          <mat-form-field class="form__field"
                          appearance="outline">
            <mat-label>Social security number</mat-label>
            <input matInput
                   formControlName="ssn"
                   mask="000-00-0000" />
            <mat-error *ngIf="ownerForm.get('ssn').errors | hasControlError:['required']">Social security number is required.</mat-error>
            <mat-error *ngIf="ownerForm.get('ssn').errors | hasControlError:['maxlength', 'minlength', 'pattern']">Please enter a valid social security number.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <div *ngIf="form.controls.length < maxNumberOfOwners"
         class="form__actions">
      <button mat-button
              (click)="addOwner()"
              color="primary">
        <mat-icon>add_circle</mat-icon>
        <span>ANOTHER OWNER</span>
      </button>
    </div>
  </form>

</mat-expansion-panel>
